import { render } from "./DefaultDataMaterial.vue?vue&type=template&id=369d6f73"
import script from "./DefaultDataMaterial.vue?vue&type=script&lang=js"
export * from "./DefaultDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__